export const SECTIONS_CONSTANTS = {
  SECTIONS_COLLAPSED_SESSION_KEY: 'sectionsCollapsed',
};
